// 拿到封装好的网络请求工具包
import request from '../utils/request'
// 获取图片
export const findPic = params => request({
  url: '/api/pic/findPic',
  // 要传的参数
  params,
  headers: { 'Token-Circus': window.localStorage.getItem('Token-Circus') },
})